import type { Goal, GoalsResponse, GoalTargetType } from "@atlas/shared";
import { apiGet, apiPost, apiDelete } from "../lib/api-client";

export type { Goal, GoalsResponse, GoalTargetType } from "@atlas/shared";

export function fetchGoals(): Promise<GoalsResponse> {
  return apiGet("/goals");
}

export function createGoal(params: {
  targetType: GoalTargetType;
  targetId: string;
  targetDate?: string;
}): Promise<{ goal: Goal }> {
  return apiPost("/goals", params);
}

export function deleteGoal(id: string): Promise<{ ok: boolean }> {
  return apiDelete(`/goals/${id}`);
}
